<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  campaign: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['delete', 'edit', 'send']);

const { t } = useI18n();

const statusClass = computed(() => {
  const statusMap = {
    draft: 'bg-n-slate-3 text-n-slate-11',
    scheduled: 'bg-n-blue-3 text-n-blue-11',
    processing: 'bg-n-yellow-3 text-n-yellow-11',
    sent: 'bg-n-green-3 text-n-green-11',
    paused: 'bg-n-orange-3 text-n-orange-11',
    failed: 'bg-n-red-3 text-n-red-11',
  };
  return statusMap[props.campaign.status] || statusMap.draft;
});

const statusLabel = computed(() => {
  return t(`BUHOTEXT_CAMPAIGNS.STATUS.${props.campaign.status.toUpperCase()}`);
});

const formattedDate = computed(() => {
  if (!props.campaign.scheduled_at) return '--';
  return new Date(props.campaign.scheduled_at).toLocaleString();
});

const canSend = computed(() => {
  return (
    props.campaign.status === 'draft' || props.campaign.status === 'scheduled'
  );
});
</script>

<template>
  <tr>
    <td class="py-4 ltr:pr-4 rtl:pl-4 truncate">{{ campaign.name }}</td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">{{ campaign.device_code || '--' }}</td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <span
        :class="statusClass"
        class="px-2 py-1 rounded-full text-xs font-medium"
      >
        {{ statusLabel }}
      </span>
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">{{ formattedDate }}</td>
    <td class="py-4 flex justify-end gap-1">
      <Button
        v-if="canSend"
        v-tooltip.top="$t('BUHOTEXT_CAMPAIGNS.SEND.TOOLTIP')"
        icon="i-lucide-send"
        slate
        xs
        @click="emit('send', campaign)"
      />
      <Button
        v-tooltip.top="$t('BUHOTEXT_CAMPAIGNS.EDIT.TOOLTIP')"
        icon="i-lucide-pen"
        slate
        xs
        @click="emit('edit', campaign)"
      />
      <Button
        v-tooltip.top="$t('BUHOTEXT_CAMPAIGNS.DELETE.TOOLTIP')"
        icon="i-lucide-trash-2"
        destructive
        xs
        @click="emit('delete', campaign)"
      />
    </td>
  </tr>
</template>
